import { CaretDownIcon } from 'components/icons';
import styled from 'styled-components';

export const Container = styled(CaretDownIcon)`
  color: ${({ theme }) => theme.colors.accent};
  margin: 0 0.75rem 0 1rem;
  width: 0.6rem;
`;
